import { Component, OnInit } from '@angular/core';
import { MigrationeService } from '@app/services/migration/migration.service';
import { UserCertificate } from '@app/store/models';
import { GlobalState } from '@app/store/store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';

const MIN_COUNT = 5;
@UntilDestroy()
@Component({
  selector: 'app-migration-banner',
  templateUrl: './migration-banner.component.html',
  styleUrls: ['./migration-banner.component.scss'],
  standalone: false,
})
export class MigrationBannerComponent implements OnInit {
  certificate: UserCertificate | undefined;
  myDate = new Date();
  constructor(
    private store: Store<GlobalState>,
    private migrationService: MigrationeService
  ) {}

  modalMessageType: 'info' | 'warning' = 'info';

  get modalMessageTypeUpperCase(): string {
    return this.modalMessageType.toUpperCase();
  }

  ngOnInit(): void {
    this.store
      .pipe(
        untilDestroyed(this),
        tap(store => {
          this.certificate = store.certificate;
        })
      )
      .subscribe();
  }

  ngAfterViewInit(): void {
    //tutte le volte che si va in homepage si apre la modale di migrazione
    //come posso chiamare in inglese la data ultima per effettura la migrazione?
    //

    this.modalMessageType = this.migrationService.checkMigrationModalType();

    this.openMigrationMessageModal();
    /* var data = JSON.parse(
      localStorage.getItem('ice-mysign_certificate')
    ).validityTo;*/
    //     const date = moment(this.myDate);
    //     const expirationDate = moment(this.certificate.validityTo);
    //     const differenceBetweenDate = expirationDate.diff(date, 'days');
    //     console.log(date);
    //     console.log(expirationDate);
    //     console.log(
    //       'La differenza in giorni tra le due date è: ',
    //       differenceBetweenDate
    //     );
    //     if (differenceBetweenDate > 90) {
    //       this.renew = !this.renew;
    //     }
  }

  public migrationModalVisible = false;
  public migrationMessageModalVisible = false;

  //se siamo in warning la modale non può essere chiusa
  openMigrationModal(closeMessage: boolean = false) {
    if (closeMessage) {
      this.migrationMessageModalVisible = false;
    }
    this.migrationModalVisible = true;
    this.migrationService.setMigrationModalVisible(true);
  }

  openMigrationMessageModal() {
    this.migrationMessageModalVisible = true;
  }

  onToggleMigrationModal(visible: boolean): void {
    this.migrationModalVisible = visible;
    this.migrationService.setMigrationModalVisible(visible);
    if (!visible) {
      this.closeModal();
    }
  }

  onToggleMigrationMessageModal(visible: boolean): void {
    this.migrationMessageModalVisible = visible;
    if (!visible) {
      this.closeModal();
    }
  }

  closeModal() {
    this.migrationModalVisible = false;
    this.migrationMessageModalVisible = false;
    this.migrationService.setMigrationModalVisible(false);
  }
}
